/**
 * Temporary platform identity, matching the legacy billing application.
 * This is a navigation convenience only. sg-sites repeats the check through
 * PlatformAdminMiddleware on every API request and remains authoritative.
 */
export const PLATFORM_ADMIN_EMAIL = 'admin@salesground.ai';

export function isPlatformAdminEmail(email: string | null | undefined): boolean {
  return email === PLATFORM_ADMIN_EMAIL;
}
